import { InjectionToken } from '@angular/core';
import { StreamPlayLiveConfiguration } from './live-service/stream-play-live.module';

export const STREAM_PLAY_LIVE_CONFIG_TOKEN = new InjectionToken<StreamPlayLiveConfiguration>('StreamPlayLiveConfiguration');
